import { useMemo } from 'react';
import { hooks, models } from "@vote4dance/judging-sdk";
var ActiveCompetitionSource = models.competitions.ActiveCompetitionSource;
var Stream = hooks.streams.Stream;
import { CompetitionStatus } from "@vote4dance/judging-schema";
const { useStreamResource } = hooks.streamResources;
export function useCompetition(competition_id) {
    const [allCompetitions, loading, error] = Stream(competition_id ? ActiveCompetitionSource(competition_id) : undefined);
    const derived = deriveCompetitionState(allCompetitions, competition_id);
    return [
        derived.inputCompetition,
        derived.event,
        derived.competitions,
        loading,
        error,
        derived.canEdit,
    ];
}
const deriveCompetitionState = (allCompetitions, competition_id) => {
    const event = allCompetitions && allCompetitions[0];
    const competitions = allCompetitions ? allCompetitions.filter((event) => event.competition_parent_id != null && parseInt(event.competition_parent_id) > 0) : [];
    const inputCompetition = allCompetitions && allCompetitions.find((event) => event.competition_id == competition_id);
    const canEdit = allCompetitions ? allCompetitions.some(a => ![CompetitionStatus.Closed, CompetitionStatus.Archived].includes(a.competition_status)) : false;
    return {
        inputCompetition,
        event,
        competitions,
        canEdit,
    };
};
export const useCompetitionResource = (competition_id) => {
    const source = useMemo(() => competition_id ? ActiveCompetitionSource(competition_id) : undefined, [competition_id]);
    return useStreamResource(source);
};
export const useCompetitionSuspense = (competition_id) => {
    if (!competition_id) {
        return {
            inputCompetition: undefined,
            event: undefined,
            competitions: undefined,
            canEdit: false,
        };
    }
    const resource = useCompetitionResource(competition_id);
    if (!resource) {
        return {
            inputCompetition: undefined,
            event: undefined,
            competitions: undefined,
            canEdit: false,
        };
    }
    const allCompetitions = resource.read();
    return deriveCompetitionState(allCompetitions, competition_id);
};
